<template>
  <div class="flex flex-col justify-between items-start box-border w-full mt-4 p-3">
    <div class="flex gap-1 flex-col sm:flex-row flex-wrap items-start justify-start w-full">
      <FiltersComponent
        :allowFilter="{
          team: true,
          tag: true
        }"
        :max="collaborationMaxSelection"
        :multiple="false"
        :modelValue="selections"
        @update:modelValue="saveSelection"
      />
    </div>
    <MessageBoxComponent is-warning :text="collaborationWarning" />
    <div class="flex flex-col lg:flex-row relative w-full justify-start items-stretch box-border
      mt-5 text-left gap-3">
      <div class="w-full min-h-52 flex flex-col lg:w-3/5 card lg:min-h-96">
        <div class="flex w-full justify-between items-center">
          <h2>
            {{ $t('mngDashboardComponent.collaborationTrendOverTime') }}</h2>
          <Select v-model="KSSSelectFilter" :options="collaborationTrendPeriod" optionLabel="name"
          option-value="identifier" @change="applyKSSFilter"/>
        </div>
        <div class="relative w-full h-[400px] min-h-[400px]" tabindex="0">
          <CollaborationTrendChart ref="collaborationTrend" />
        </div>
      </div>
      <div class="w-full min-h-52 flex justify-start items-start flex-col box-border
        lg:w-2/5 gap-3">
        <div v-show="showAverageChart" class="card w-full">
          <div class="w-full flex justify-between items-center">
            <h2>{{ $t('mngDashboardComponent.trackerUsage') }}</h2>
            <Select v-model="avgKSSSelectFilter" :options="collaborationTrendPeriod"
              optionLabel="name" option-value="identifier" @change="applyAvgKSSFilter"/>
          </div>
          <div class="relative h-44 w-full p-3 mt-3 box-border min-h-44">
            <AvgCollaborationTrendChart ref="avgCollaborationTrend" />
          </div>
        </div>
        <div v-if="collaborationTrendText?.headline || collaborationTrendText?.text"
          class="text-white flex flex-col items-start w-full bg-[var(--color-orange)] rounded-xl
            box-border p-4">
          <div class="flex">
            <img src="@/assets/light.svg" alt="light" />
            <h3 v-html="collaborationTrendText?.headline" class="ml-3"></h3>
          </div>
          <p v-html="collaborationTrendText?.text" class="font-light text-sm"></p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import '../managementDashboard.css';
import CollaborationTrendChart from '@/components/Home/ManagementDashboard/CollaborationTrendComponent/CollaborationTrendChartComponent.vue';
import AvgCollaborationTrendChart from '@/components/Home/ManagementDashboard/CollaborationTrendComponent/AvgCollaborationChartComponent.vue';
import FiltersComponent from '@/components/Home/ManagementDashboard/common/FiltersComponent.vue';
import MessageBoxComponent from '@/components/Home/ManagementDashboard/common/MessageBoxComponent.vue';
import { Select } from 'primevue';

export default {
  name: 'CollaborationTrendComponent',
  data() {
    return {
      KSSSelectFilter: 'Last7Days',
      avgKSSSelectFilter: 'Last7Days',
      showAverageChart: true,
    };
  },
  components: {
    CollaborationTrendChart,
    AvgCollaborationTrendChart,
    FiltersComponent,
    MessageBoxComponent,
    Select,
  },
  computed: {
    selections: {
      get() {
        return this.$store.getters.getSelections;
      },
      set(value) {
        this.$store.commit('setSelections', value);
      },
    },
    collaborationTrendOverTimeData() {
      return this.$store.getters.getCollaborationKss?.collaborationTrendOverTimeData;
    },
    avgCollaborationTrendData() {
      return this.$store.getters.getCollaborationKss?.avgCollaborationTrendData;
    },
    collaborationTrendText() {
      return this.$store.getters.getCollaborationKss?.collaborationTrendText;
    },
    collaborationTrendPeriod() {
      return this.$store.getters.getCollaborationKss?.collaborationTrendPeriod;
    },
    collaborationMaxSelection() {
      return this.$store.getters.getCollaborationKss?.maxSelection;
    },
    collaborationWarning() {
      return this.$store.getters.getCollaborationKss?.warning;
    },
  },
  methods: {
    // --------- Main Function to call the api on every filters change ---------------- //
    async KSSTrendOverAllFunction(isKSSTrend) {
      try {
        await this.$store.dispatch('fetchInitialCollaborationTrendData', {
          selections: this.selections,
          kssPeriodType: this.KSSSelectFilter,
          avgKssPeriodType: this.avgKSSSelectFilter,
        });
        if (isKSSTrend === 'isKSSTrend') {
          this.$refs.collaborationTrend?.collaborationTrendChart(
            this.collaborationTrendOverTimeData,
          );
        } else if (isKSSTrend === 'isAvgKSSTrend') {
          this.$refs.avgCollaborationTrend?.avgCollaborationTrendChart(
            this.avgCollaborationTrendData,
          );
        } else {
          this.$refs.collaborationTrend?.collaborationTrendChart(
            this.collaborationTrendOverTimeData,
          );
          this.$refs.avgCollaborationTrend?.avgCollaborationTrendChart(
            this.avgCollaborationTrendData,
          );
        }
      } catch (error) {
        console.error(error);
        this.$toast.add({
          severity: 'error',
          summary: 'Error! Check Console output!',
          detail: '',
          life: 3000,
        });
      }
    },
    // --------------- Filters---------------- //
    applyKSSFilter() {
      this.KSSTrendOverAllFunction('isKSSTrend');
    },
    applyAvgKSSFilter() {
      this.KSSTrendOverAllFunction('isAvgKSSTrend');
    },
    saveSelection(selection) {
      this.selections = selection;
    },
  },
  watch: {
    selections() {
      this.KSSTrendOverAllFunction('');
    },
  },
  mounted() {
    this.KSSTrendOverAllFunction('');
  },
};
</script>
